import { DATA_ICON_STATUS } from 'consts/enum';
import { addClass } from 'helpers/helpers';
import { bad, excellent, fair, good, okay } from 'icons/emojis.js';
import { star } from 'icons/star.js';
import { ENGT_CHAT } from 'js/bot.model';
import { ratingsButtonOptions } from './rating.model';
import './rating.scss';

const { IS_DISABLED, IS_HOVERED, IS_SELECTED, SELECTED_INDEX } = DATA_ICON_STATUS;

const getEmoji = (index, html, li, optionsLength) => {
	addClass(html, 'engt-ratings-emoji');
	li.className = 'engt-rating engt-rating-emoji engt-tab-selectable';

	if (index === 0) {
		if (optionsLength === 2) {
			return (li.innerHTML = good());
		}
		return (li.innerHTML = bad());
	}

	if (index === 1) {
		if (optionsLength === 2) {
			return (li.innerHTML = bad());
		}
		if (optionsLength === 3) {
			return (li.innerHTML = fair());
		}
		return (li.innerHTML = okay());
	}

	if (index === 2) {
		if (optionsLength === 3) {
			return (li.innerHTML = excellent());
		}
		return (li.innerHTML = fair());
	}

	if (index === 3) {
		return (li.innerHTML = good());
	}

	if (index === 4) {
		return (li.innerHTML = excellent());
	}

	return '';
};

const getStar = (html, element) => {
	addClass(html, 'engt-ratings-star');
	element.className = 'engt-rating engt-rating-star engt-tab-selectable';
	element.innerHTML = star();
};

export class Rating {
	constructor(props) {
		this.initData(props);
		this.initWrapper();
		this.initComponents();
	}

	initData(props) {
		this.data = { ...ratingsButtonOptions };
		this.setter({
			messageId: props.msgId,
			options: props.options,
			theme: ENGT_CHAT.get('config.themeColor'),
			isOldMessage: props.isOldMessage,
		});
	}

	initWrapper() {
		const { messageId, id } = this.data;
		const wrapper = document.createElement('div');
		wrapper.className = 'engt-ratings';
		wrapper.id = messageId || id;
		wrapper.setAttribute(SELECTED_INDEX, '');
		wrapper.setAttribute(IS_DISABLED, !!this.data.isOldMessage);
		wrapper.setAttribute('data-interactive-field', '');

		this.html = wrapper;
	}

	initComponents() {
		const { options } = this.data;

		const is3Emoji = options.length === 3;

		for (let i = 0; i < options.length; i++) {
			const button = document.createElement('button');
			button.title = options[i].text;
			if (options[i].text.indexOf('⭐') > -1) {
				getStar(this.html, button);
			} else if (getEmoji(i, this.html, button, options.length)) {
				getEmoji(i, this.html, button, options.length);
			} else {
				getStar(this.html, button);
			}
			button.setAttribute(IS_HOVERED, false);
			button.setAttribute(IS_SELECTED, false);
			button.addEventListener('mouseover', function () {
				const ratings = this.parentElement.querySelectorAll('.engt-rating');
				ratings.forEach((star, index) => {
					if (index <= i) {
						star.setAttribute(IS_HOVERED, true);
					} else {
						star.setAttribute(IS_HOVERED, false);
					}
				});
			});
			button.addEventListener('mouseout', function () {
				const ratings = this.parentElement.querySelectorAll('.engt-rating');
				ratings.forEach((star) => {
					star.setAttribute(IS_HOVERED, false);
				});
			});
			button.addEventListener('click', function () {
				const ratings = this.parentElement.querySelectorAll('.engt-rating');
				ratings.forEach((star, index) => {
					if (index <= i) {
						star.setAttribute(IS_SELECTED, true);
					} else {
						star.setAttribute(IS_SELECTED, false);
					}
				});
				this.parentElement.setAttribute(SELECTED_INDEX, i);
			});

			this.html.appendChild(button);
		}
	}

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	}

	render() {
		return this.html;
	}
}
